import React, { useState } from 'react';
import { Modal, ModalBody, Row, Col, Button, Input, Container, Form, FormGroup, Label } from 'reactstrap';
import { LoadingButton } from '../LoadingButton';
import { AlertMessage } from '../AlertMessage/AlertMessage';

import useApi from '../../hooks/useApi';
import { useValidateCaseRef } from '../../hooks/useValidateCaseRef';
import { useTranslation } from 'react-i18next';

const ChangeCaseRefModal = ({
  title = 'Change Case Reference',
  titleDarkSide = '',
  subText = 'Are you sure you wish to cancel your changes?',
  noBtnHandler,
  confirmHandler,
  yesBtnText = 'Yes',
  noBtnText = 'No',
  btnsStyle = {},
  currentRef,
  case_id,
  ...restProps
}) => {
  const { t } = useTranslation('common');
  const { Api, consumed } = useApi();
  const [newCaseRef, setNewCaseRef] = useState('');
  const [loadingChangeCaseRef, setLoadingChangeCaseRef] = useState(false);
  const [showAlertMessage, setShowAlertMessage] = useState(false);
  const [alertMessage, setAlertMessage] = useState('');

  const { validateCaseRef, errorText } = useValidateCaseRef(case_id);

  const changeCaseRef = async () => {
    if (case_id && newCaseRef) {
      if (!validateCaseRef(newCaseRef)) {
        setLoadingChangeCaseRef(false);
        setAlertMessage(errorText);
        setShowAlertMessage(true);
        return;
      }
      if (currentRef === newCaseRef) {
        setLoadingChangeCaseRef(false);
        setAlertMessage('Please enter a new valid case reference');
        setShowAlertMessage(true);
        setNewCaseRef('');
      } else {
        Api.cases
          .updateCaseRef(case_id, newCaseRef)
          .then((res) => {
            console.log(res);
            setLoadingChangeCaseRef(false);
            setNewCaseRef('');
            confirmHandler();
          })
          .catch((e) => {
            console.error(e);
            setLoadingChangeCaseRef(false);
            setAlertMessage('There was an error. Please enter a new valid case reference');
            consumed(e);
            setShowAlertMessage(true);
            setNewCaseRef('');
          });
      }
    } else {
      setLoadingChangeCaseRef(false);
      console.log('insufficient parameters');
      setAlertMessage('Please enter a valid case reference');
      setShowAlertMessage(true);
    }
  };

  return (
    <Modal
      size="lg"
      {...restProps}
      centered
      className="vl-add-modal"
      backdrop={'static'}
      keyboard={false}
      data-testid="change-case-ref-modal"
    >
      <ModalBody className="p-5">
        <Container fluid={true}>
          <Row>
            <Col xs="12">
              <span className="vl-modal-title">{t('Update Case Reference')}</span>
            </Col>
            <AlertMessage message={alertMessage} visibility={showAlertMessage} />
            <Col xs="12">
              <Form className="mt-5">
                <Row>
                  <Col xs="6">
                    <Label>
                      {t('Current Case Reference: ')}
                      <span className="vl-primary-dark-text">{currentRef}</span>
                    </Label>
                  </Col>
                  <Col xs="6">
                    <FormGroup>
                      <Label>
                        {t('New Case Reference')}
                        <span className="vl-product-satsuma">*</span>
                      </Label>
                      <Input
                        data-testid="change-case-ref-input"
                        value={newCaseRef}
                        onChange={(e) => {
                          setNewCaseRef(e.target.value);
                        }}
                      />
                    </FormGroup>
                  </Col>
                  <Col xs="12" className="text-right ">
                    <Button
                      className="vl-button-gray vl-font-regular"
                      type="button"
                      disabled={loadingChangeCaseRef}
                      onClick={() => {
                        setNewCaseRef('');
                        noBtnHandler();
                      }}
                      data-testid="cancel-change-button"
                    >
                      {t('Cancel')}
                    </Button>
                    <LoadingButton
                      className="vl-button vl-font-regular"
                      onClick={() => {
                        setLoadingChangeCaseRef(true);
                        changeCaseRef();
                      }}
                      loading={loadingChangeCaseRef}
                      disabled={loadingChangeCaseRef}
                      data-testid="change-case-ref-button"
                    >
                      {t('Change Ref')}
                    </LoadingButton>
                  </Col>
                </Row>
              </Form>
            </Col>
          </Row>
        </Container>
      </ModalBody>
    </Modal>
  );
};

export { ChangeCaseRefModal };
